import {
    createBrowserRouter,
    RouterProvider,
    Outlet
  } from "react-router-dom"; 
  
  import { Header, Footer} from './components'
  import {Home, About, Showcase} from './pages'
  import { Wiifarmvest, Jaytrends, Milktheframer,Lead } from "./pages/Showcase";
  import 'react-toastify/dist/ReactToastify.css';
  import {ToastContainer} from 'react-toastify';
  
  
  const Layout = () => {
    return (
      <>
      <Header />
      <ToastContainer/>
      <Outlet />
      <Footer/>
      </>
    )
  }
  
  
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Layout/>,
      children: [
        {
          path: '/',
          element: <Home />
        },
        {
          path: '/about',
          element: <About />
        },
        {
          path: '/showcase',
          element: <Showcase />
        },
        {
          path: '/showcase/wiifarmvest',
          element: <Wiifarmvest />
        },
        {
          path: '/showcase/jaytrends',
          element: <Jaytrends />
        },
        {
          path: '/showcase/milktheframer',
          element: <Milktheframer />
        },
        {
          path: '/showcase/lead4change',
          element: <Lead />
        },
     
      ]
    },
  
  ]);
  
  function App(){
    return(
      <RouterProvider router={router}/>
    )
  }
  
  export default App